"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    autocompleteVariants: ()=>autocompleteVariants
});
const external_tailwind_variants_namespaceObject = require("tailwind-variants");
const autocompleteVariants = (0, external_tailwind_variants_namespaceObject.tv)({
    slots: {
        listWrapperSlot: 'z-100 bg-neutral-1 absolute top-[52px] flex h-[300px] w-full flex-col rounded-xl',
        overlayInputSlot: 'relative mt-1 grid w-full grid-cols-[48px_1fr] gap-3 px-3'
    },
    variants: {
        isHidden: {
            true: {
                listWrapperSlot: 'hidden'
            }
        }
    }
});
exports.autocompleteVariants = __webpack_exports__.autocompleteVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "autocompleteVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
